import { createStyles, makeStyles, Theme } from '@material-ui/core'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    application: {
      display: 'flex',
      flexDirection: 'column',
      color: theme.palette.secondary[theme.palette.type],
      background: theme.palette.primary[theme.palette.type],
      height: '100vh',
      width: '100%',
      maxWidth: '110em',
    },
    content: {
      zIndex: 0,
      display: 'flex',
      marginTop: '6.2em',
      [theme.breakpoints.up('tablet')]: {
        marginTop: '9.2em',
      },
      background: 'transparent',
    },
    main: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      justifyContent: 'space-between',
      background: theme.palette.primary[theme.palette.type],
    },
    header: {
      zIndex: 2,
      position: 'fixed',
      width: '100%',
      borderBottom: 'solid',
      borderBottomColor: '#B4D620',
      background: theme.palette.primary[theme.palette.type],
    },
    backgroundImage: {
      zIndex: 0,
      position: 'absolute',
      width: '100%',
      height: '100vh',
      backgroundSize: 'cover',
      top: 0,
      left: 0,
      backgroundImage: 'url("/background.jpg")',
      backgroundPosition: 'center',
    },
    designedBy: {
      position: 'absolute',
      right: '1.5em',
      bottom: '1em',
      color: 'white',
      fontStyle: 'italic',
      fontSize: '7px',
    },
  })
)
